const policyLinks = [
  { key: 'privacy', label: 'Privacy Policy', href: 'https://www.kalamanch.art/privacy-policy' },
  { key: 'terms', label: 'Terms & Conditions', href: 'https://www.kalamanch.art/terms-and-conditions' },
  { key: 'trust', label: 'Trust & Safety', href: 'https://www.kalamanch.art/trust-safety' },
];

const PolicyConsentChecklist = ({ value, onChange, tone = 'orange' }) => {
  const accentClass = tone === 'teal' ? 'accent-[#00BFA5]' : 'accent-[#FF6F00]';
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
      <p className="text-sm font-bold text-slate-900">Required policy acceptance</p>
      <p className="mt-1 text-xs leading-5 text-slate-600">
        Please open and read each page, then tick all three boxes to continue.
      </p>
      <div className="mt-3 space-y-2">
        {policyLinks.map((policy) => (
          <label key={policy.key} className="flex items-start gap-3 text-sm font-semibold text-slate-700">
            <input
              type="checkbox"
              checked={Boolean(value?.[policy.key])}
              onChange={(event) => onChange(policy.key, event.target.checked)}
              className={`mt-1 h-4 w-4 ${accentClass}`}
              required
            />
            <span>
              I have read and agree to the{' '}
              <a
                href={policy.href}
                target="_blank"
                rel="noreferrer"
                className="font-black text-[#4A148C] underline underline-offset-2"
              >
                {policy.label}
              </a>
              .
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export const emptyPolicyConsent = {
  privacy: false,
  terms: false,
  trust: false,
};

export const hasAcceptedAllPolicies = (value = {}) =>
  Boolean(value.privacy && value.terms && value.trust);

export default PolicyConsentChecklist;
